export function tab() {
  const tabMenu = document.querySelectorAll(".c-tab__menuItem");
  const tabContent = document.querySelectorAll(".c-tab__contentItem");

  tabMenu.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      // クリックされたタブ以外の.js-tab-activeを外し、対応するタブコンテンツを非表示に
      tabMenu.forEach((otherTab, otherIndex) => {
        if (otherIndex !== index) {
          otherTab.classList.remove("_is-active");
          tabContent[otherIndex].style.display = "none";
        }
      });

      // 現在のタブボタンとタブコンテンツをアクティブに設定
      tab.classList.add("_is-active");
      tabContent[index].style.display = "block";
    });
  });
}
